import api from "@/Library/api.js";
import method from "@/Library/method.js";
let apiresult;
let controller;
let action;
let url;

export default {

    
    /** 获取配送费列表 **/
    GET_SHIPPING_LIST(data) {
        controller='EsShipping';
        action='GetShippingList';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },
   
    /** 获取配送费详情 **/
    GET_SHIPPING_INFO(data) {
        controller='EsShipping';
        action='GetShippingInfo';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 新增配送费 **/
    ADD_SHIPPING(data) {
        controller='EsShipping';
        action='AddShipping';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 编辑配送费 **/
    EDIT_SHIPPING(data) {
        controller='EsShipping';
        action='EditShipping';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 删除配送费 **/
    DEL_SHIPPING(data) {
        controller='EsShipping';
        action='DelShipping';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取配送费类型 **/
    GET_SHIPPING_TYPE(data) {
        controller='EsShipping';
        action='GetTypeList';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取配送时间类型刻度 **/
    GET_SHIPPING_TIME_SCALE(data) {
        controller='EsShipping';
        action='GetTimeScale';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },


}